"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
exports.default = (0, react_1.css) `
    .sidebyside__options {
        width: 100%;
        position: relative;
        display: flex;
        gap: var(--sbs-gap-desktop);
    }

    .sidebyside__option {
        position: relative;
        cursor: pointer;

        width: var(--sbs-image-container-width-desktop);
        height: var(--sbs-image-container-height-desktop);

        border-radius: var(--sbs-unchecked-outer-radius);
        border-width: var(--sbs-unchecked-border-width);
        border-style: var(--sbs-unchecked-border-style);
        border-color: var(--sbs-unchecked-border-color);
    }
    .sidebyside__option-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
    .sidebyside__option_checked {
        border-radius: var(--sbs-checked-outer-radius);
        border-width: var(--sbs-checked-border-width);
        border-style: var(--sbs-checked-border-style);
        border-color: var(--sbs-checked-border-color);
        padding: 0;
    }
    .sidebyside__image-underlay {
        background-color: var(--sbs-underlay-bg);
        display: flex;
        width: 100%;
        height: 100%;
        border-radius: var(--sbs-unchecked-inner-radius);
    }

    .sidebyside__image-underlay:hover {
        background-color: var(--sbs-underlay-bg-hover);
    }

    .sidebyside__image {
        display: flex;
        border-radius: var(--sbs-unchecked-inner-radius);
        z-index: 100;
        width: 100%;
        height: 100%;

        object-fit: var(--sbs-image-scale-type);
        align-items: center;
        justify-content: center;
    }

    .sidebyside__option_checked .sidebyside__image-underlay,
    .sidebyside__option_checked .sidebyside__image {
        border-radius: var(--sbs-checked-inner-radius);
    }

    .sidebyside__loop {
        display: var(--sbs-loop-display-desktop);
        opacity: var(--sbs-loop-opacity);
        position: absolute;
        right: 12px;
        top: 12px;
        z-index: 101;
    }

    .sidebyside__option:hover .sidebyside__loop {
        display: block;
    }

    .sidebyside__option-container .choice__option {
        order: var(--sbs-radiobutton-order);
    }

    .sidebyside__option-container .choice__option .choice__option-label {
        justify-content: var(--sbs-radiobutton-position);
    }

    .question_theme_ugc-cab,
    .question_theme_ugc-cab .question__content,
    .question_theme_ugc-cab .question__content-wrapper,
    .question_theme_ugc-cab .sidebyside {
        height: 100%;
    }

    .question_theme_ugc-cab .sidebyside {
        display: flex;
        flex-direction: column;
    }

    .question_theme_ugc-cab .sidebyside__option-container {
        margin-bottom: -16px;

        flex: 1;
        overflow-y: scroll;
    }

    .question_theme_ugc-cab .sidebyside__option-image {
        margin-bottom: 16px;

        display: flex;

        width: 100%;
    }

    .question_theme_ugc-cab .sidebyside__bottom-controls {
        padding: 20px 24px 8px;

        display: flex;
        flex-direction: column;
        align-items: stretch;

        color: #fff;
        background: #222;
        border-radius: 16px 16px 0 0;

        z-index: 1;
    }

    .question_theme_ugc-cab .sidebyside__question-label {
        margin-bottom: 12px;

        color: #e0e0e0;
    }

    .question_theme_ugc-cab .sidebyside__question-label p {
        margin: 0;

        font-size: 16px;
        line-height: 19px;
        font-weight: bold;
    }

    .question_theme_ugc-cab .sidebyside__option-switch {
        padding: 5px;

        display: flex;

        background: #565656;
        border-radius: 6px;
    }

    .question_theme_ugc-cab .sidebyside__option-switch input {
        display: none;
    }

    .question_theme_ugc-cab .sidebyside__option-button {
        padding: 15px 4px;

        flex: 1;

        font-size: 16px;
        line-height: 19px;
        font-weight: bold;
        text-align: center;

        color: #fff;
        background: transparent;
        border-radius: 4px;

        cursor: pointer;
    }

    .question_theme_ugc-cab .sidebyside__option-button_checked {
        color: #000;
        background: #fff;
    }

    .question_theme_ugc-cab .sidebyside__option-button_active {
        color: #ffd600;
    }

    .question_theme_ugc-cab .sidebyside__no-answer-button {
        padding: 12px 4px;

        flex: 1;

        font-size: 16px;
        line-height: 19px;

        color: #b4b4b4;
        background: transparent;
        border: 0;
        border-radius: 4px;

        outline: none;

        cursor: pointer;
    }

    .question_theme_ugc-cab .sidebyside__option-switch + .sidebyside__no-answer-button {
        margin-top: 8px;
    }

    @media (max-width: 860px) {
        .sidebyside__loop {
            display: block;
        }
        .sidebyside__options {
            flex-direction: column;

            gap: var(--sbs-gap-mobile);
        }
        .sidebyside__option-container .choice__option {
            width: var(--choice-option-control-width);
            order: var(--sbs-radiobutton-order-mobile);
        }
        .sidebyside__option-container {
            flex-direction: row;
        }

        .sidebyside__option-container .choice__option .choice__option-label {
            align-self: var(--sbs-radiobutton-position-mobile);
        }
    }

    @media (max-width: 480px) {
        .sidebyside__loop {
            display: flex;
            align-items: center;
            border-radius: 10px;
            width: 32px;
            height: 32px;
            right: 8px;
            top: 8px;
        }
        .sidebyside__option {
            width: var(--sbs-image-container-width-mobile);
            height: var(--sbs-image-container-height-mobile);
        }
    }
`;
